import { render, staticRenderFns } from "./observation.vue?vue&type=template&id=44edbefe&scoped=true&lang=pug&"
import script from "./observation.vue?vue&type=script&lang=ts&"
export * from "./observation.vue?vue&type=script&lang=ts&"
import style0 from "./observation.vue?vue&type=style&index=0&id=44edbefe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44edbefe",
  null
  
)

export default component.exports